import React from "react";

import './element-styles.scss';

const Button = (props) => {
  return <button className="main-button" {...props}>{props.children}</button>;
};

export default Button;
